module.exports = __webpack_public_path__ + "market/static/img/luckdraw_bg.4a601f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/luckdraw_bg.png
// module id = 50In
// module chunks = 1